// Reconstructed from the supplied production build; original component names were unavailable.
const PrivacyPage = () => (
  <div className={"max-w-4xl mx-auto p-6 text-gray-800"}>
    <h1 className={"text-4xl font-bold mb-6 text-center text-blue-700"}>{"Privacy Policy"}</h1>
    <p className={"text-sm text-gray-500 mb-8 text-center"}>{"Effective Date: May 25, 2025"}</p>
    <section className={"mb-8"}>
      <h2 className={"text-2xl font-semibold mb-2"}>{"1. Introduction"}</h2>
      <p>
        {"Welcome to "}
        <strong>{"CodeBruh"}</strong>
        {
          ' ("we", "our", "us"). This Privacy Policy outlines how we handle your personal data when you use our website.'
        }
      </p>
    </section>
    <section className={"mb-8"}>
      <h2 className={"text-2xl font-semibold mb-2"}>{"2. Information We Collect"}</h2>
      <ul className={"list-disc pl-5 space-y-1"}>
        <li>
          <strong>{"Personal Info:"}</strong>
          {" Name, Email, Payment details"}
        </li>
        <li>
          <strong>{"Technical Info:"}</strong>
          {" IP address, device, browser"}
        </li>
        <li>
          <strong>{"Usage Data:"}</strong>
          {" Page views, click paths, time spent"}
        </li>
      </ul>
    </section>
    <section className={"mb-8"}>
      <h2 className={"text-2xl font-semibold mb-2"}>{"3. How We Use Your Data"}</h2>
      <ul className={"list-disc pl-5 space-y-1"}>
        <li>{"To provide and improve our services"}</li>
        <li>{"To process transactions and customer support"}</li>
        <li>{"To send updates, newsletters, or offers (if opted-in)"}</li>
        <li>{"To protect against fraud or abuse"}</li>
      </ul>
    </section>
    <section className={"mb-8"}>
      <h2 className={"text-2xl font-semibold mb-2"}>{"4. Sharing of Information"}</h2>
      <p>
        {
          "We do not sell your data. However, we may share it with service providers (e.g., hosting, payment, analytics) or in case of legal obligations or business transfers."
        }
      </p>
    </section>
    <section className={"mb-8"}>
      <h2 className={"text-2xl font-semibold mb-2"}>{"5. Cookies & Tracking"}</h2>
      <p>
        {
          "We use cookies to analyze site traffic, enhance user experience, and remember your preferences. You can control cookies via your browser settings."
        }
      </p>
    </section>
    <section className={"mb-8"}>
      <h2 className={"text-2xl font-semibold mb-2"}>{"6. Data Security"}</h2>
      <p>
        {
          "We implement appropriate measures to protect your data. However, no method of online transmission is 100% secure."
        }
      </p>
    </section>
    <section className={"mb-8"}>
      <h2 className={"text-2xl font-semibold mb-2"}>{"7. Your Rights"}</h2>
      <p>
        {
          "Depending on your region, you have the right to access, correct, or delete your personal data, and object to its processing. Email us at"
        }{" "}
        <a href={"mailto:codebruh@kestroinfotech.com"} className={"text-blue-600 underline"}>
          {"codebruh@kestroinfotech.com"}
        </a>{" "}
        {"to exercise these rights."}
      </p>
    </section>
    <section className={"mb-8"}>
      <h2 className={"text-2xl font-semibold mb-2"}>{"8. Children’s Privacy"}</h2>
      <p>
        {
          "Our services are not intended for users under 13. We do not knowingly collect data from children. If you believe we have, please contact us."
        }
      </p>
    </section>
    <section className={"mb-8"}>
      <h2 className={"text-2xl font-semibold mb-2"}>{"9. Updates"}</h2>
      <p>
        {
          "We may update this policy from time to time. Please revisit this page periodically to stay informed."
        }
      </p>
    </section>
    <section>
      <h2 className={"text-2xl font-semibold mb-2"}>{"10. Contact Us"}</h2>
      <p>
        {"For questions about this policy, email us at"}{" "}
        <a href={"mailto:codebruh@kestroinfotech.com"} className={"text-blue-600 underline"}>
          {"codebruh@kestroinfotech.com"}
        </a>
        {"."}
      </p>
    </section>
  </div>
);
export { PrivacyPage };
